import {
  Typography,
  Breadcrumbs,
  Link,
  Card,
  CardActions,
  CardContent,
  Button,
} from "@mui/material";
import { useGetRecordsCountsQuery } from "redux/api/slices/server";
import { Pane, Spinner } from "evergreen-ui";

const DashboardPage = () => {
  const requestServer = useGetRecordsCountsQuery();

  if (requestServer.isLoading) {
    return (
      <div className="w-full flex justify-center items-center">
        <Pane>
          <Spinner marginX="auto" size={60} marginTop={25} marginBottom={50} />
          <Typography variant="h5" gutterBottom>
            İşlem Yapılıyor. Lütfen Bekleyniz...
          </Typography>
        </Pane>
      </div>
    );
  }

  return (
    <div className="w-full my-6">
      <div className="w-full h-auto container mx-auto">
        <div className="w-full mb-6">
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Ana Ekran
            </Link>
            <Typography color="text.primary">Ana Ekran</Typography>
          </Breadcrumbs>
        </div>
        <div className="w-full flex items-center gap-2 p-3 mb-6 border shadow bg-white">
          <Typography variant="body1" component="div">
            Site:
          </Typography>
          <Typography variant="body1" component="div">
            {process.env.REACT_APP_SITE}
          </Typography>
        </div>
        <div className="w-full flex items-center gap-5">
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                Ürün Makaleleri
              </Typography>
              <Typography variant="h5" component="div">
                {requestServer?.data?.articleCount}
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                Kayıtlı Makale
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small" href="/articles">
                Makaleler
              </Button>
            </CardActions>
          </Card>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                Ürünler
              </Typography>
              <Typography variant="h5" component="div">
                {requestServer?.data?.productCount}
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                Kayıtlı Ürün
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small" href="/products/0">
                Ürünler
              </Button>
            </CardActions>
          </Card>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                Ürün Kategorileri
              </Typography>
              <Typography variant="h5" component="div">
                {requestServer?.data?.categoryCount}
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                Kayıtlı Kategoriler
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small" href="/categories/0" lang="tr">
                Kategoriler
              </Button>
            </CardActions>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
